module.exports = "label {\n  overflow-x: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis; }\n\n.panel-heading {\n  background-color: lightgray; }\n\n.group-btn {\n  font-size: 10px; }\n\n.group-btn button {\n  height: 15px;\n  padding-top: 0px;\n  text-align: center;\n  font-size: 10px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/vild/linear/linear-vild.component.scss
// module id = ./src/app/shared/vild/linear/linear-vild.component.scss
// module chunks = main